import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useClassName, useWindowSize } from 'common/hooks';

import { BottomSheet } from '../BottomSheet';

import './alert.less';
import { SVGIcon } from 'common/components';
import { Modal } from 'common/lazy';

const Alert = ({ text, onClose }) => {
  const [isOpen, setIsOpen] = useState(true);
  const { isMobile } = useWindowSize();
  const classNames = useClassName('SimpleAlertDialog');

  const handleClose = () => {
    setIsOpen(false);
    onClose();
  };

  if (isMobile) {
    return (
      <BottomSheet
        onClose={handleClose}
        isOpen={isOpen}
        title="Alert"
        className={classNames('container')}
        content={<div className={classNames('content')}>{text}</div>}
      />
    );
  }

  return (
    <Modal
      onClose={handleClose}
      open={isOpen}
      size="small"
      className={classNames('container')}>
      <Modal.Content className={classNames('content')}>
        <div className={classNames('header')}>
          <h1>Alert</h1>
          <div className={classNames('close')} onClick={handleClose}>
            <SVGIcon name="close" />
          </div>
        </div>
        {text}
      </Modal.Content>
    </Modal>
  );
};

Alert.propTypes = {
  text: PropTypes.string.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default Alert;
